exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".markerSettings{display:flex;height:25px;flex-flow:row nowrap;padding:0;line-height:25px}.markerSettingsSpacer{flex:1}", ""]);

